import UserUtil from '../util/UserUtil'
import store from '@/store/store'

export default {
  // https://dev.to/nkoik/writing-a-very-simple-plugin-in-vuejs---example-8g8
  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$userCan = (permiso) => {
      return UserUtil.can(store.state.userInfo, permiso)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/UserCan.js